var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7188 5.75368C20.5416 5.62984 20.3109 5.58679 20.0936 5.63695C18.6139 5.85563 17.0952 5.64972 15.7528 5.04803C14.4103 4.44633 13.3121 3.47931 12.6134 2.28434C12.4719 2.10578 12.2433 2 11.9996 2C11.756 2 11.5274 2.10578 11.3859 2.28434C8.37367 6.57717 4.08725 5.67584 3.90581 5.637C3.68853 5.58684 3.45788 5.62988 3.28067 5.75372C3.10368 5.87756 3 6.06834 3 6.27022V12.9251C3 19.0813 10.2193 22 12 22C13.7807 22 21 19.0814 21 12.9251V6.27022C21 6.06832 20.8965 5.87754 20.7193 5.75372L20.7188 5.75368ZM19.5479 12.925C19.5479 18.3556 13.0347 20.6925 11.9994 20.6925C10.9642 20.6925 4.45096 18.3554 4.45096 12.925V7.01387C5.91058 7.09613 7.36963 6.84224 8.6901 6.2761C10.0106 5.70997 11.1495 4.8502 11.9992 3.77813C12.8476 4.85146 13.9861 5.71217 15.3071 6.2783C16.6279 6.84462 18.0876 7.09778 19.5474 7.01387L19.5479 12.925Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacy);
export default __webpack_public_path__ + "static/media/data-privacy.7e44968985973037b7e23630fc0284e9.svg";
export { ForwardRef as ReactComponent };